import { Device } from '../types/device';
import { logger } from './logger';

export class PsrAssessmentError extends Error {
  constructor(message: any) {
    super(message);
    this.name = this.constructor.name;
    window?.newrelic.noticeError(this);
  }
}

export class ApiRequestFailureError extends Error {
  constructor(endpoint: any, meta: any) {
    super(`Endpoint Failure at: ${endpoint}`);
    this.name = this.constructor.name;
    window?.newrelic.noticeError(this, {
      apiResponse: meta?.res,
      apiRequest: meta?.init,
    });
  }
}

export class ApiRequestPayloadError extends PsrAssessmentError {
  constructor(attribute: any) {
    super(`Missing payload attribute: ${attribute}`);
    this.name = this.constructor.name;
  }
}

export class AccessCodeError extends PsrAssessmentError {
  constructor(code: any, error: any) {
    super(`Access Code Error for : ${code}`);
    this.name = this.constructor.name;
    window?.newrelic.noticeError(this, {
      code,
      error,
    });
  }
}

export class PartnerWebConfigError extends PsrAssessmentError {
  constructor(partner: any) {
    super(`Missing Web Config for : ${partner}`);
    this.name = this.constructor.name;
  }
}

export class UserNotFoundError extends PsrAssessmentError {
  constructor(email: string) {
    super(`User with email ${email} does not exist`);
    this.name = UserNotFoundError.name;
    logger(this.name, email);
  }
}

export class AccountCreationFailed extends Error {
  constructor(meta?: any) {
    super(`Could not create account`);
    console.log('throing AccountCreationFailed');
    this.name = AccountCreationFailed.name;
    window?.newrelic.noticeError(this, {
      apiResponse: meta?.res,
      apiRequest: meta?.init,
    });
  }
}

export class UserNotAuthenticated extends PsrAssessmentError {
  constructor(err?: unknown) {
    super(`User is not Authenticated, missing user object in Context`);
    this.name = UserNotAuthenticated.name;
    logger(this.name, err);
  }
}

export class EligibilityChecksAttemptsExceeded extends PsrAssessmentError {
  constructor(err?: unknown) {
    super(`Too many eligibility checks attempted`);
    this.name = EligibilityChecksAttemptsExceeded.name;
    logger(this.name, err);
  }
}

export class EligibilityCheckFailed extends PsrAssessmentError {
  constructor(err?: unknown) {
    super(`Eligibility check failed`);
    this.name = EligibilityCheckFailed.name;
    logger(this.name, err);
  }
}

export class UserEnrollmentError extends PsrAssessmentError {
  constructor(userId: any) {
    super(
      `Could not enroll user: ${userId}. Called in /v1/users/${userId}/programs`
    );
    this.name = this.constructor.name;
  }
}

export class UserOnboardingError extends PsrAssessmentError {
  constructor(userId: any) {
    super(
      `Could not onboard user: ${userId}. Called in /v3/users/${userId}/onboarding/initialize`
    );
    this.name = this.constructor.name;
  }
}

export class NativeBridgeConnectionError extends Error {
  constructor(device: Device) {
    super(`Native bridge connection error: ${device}`);
    this.name = this.constructor.name;
    window?.newrelic.noticeError(this, {
      device,
    });
  }
}

export class NativeMethodError extends Error {
  constructor(device: Device, method: string) {
    super(`Native bridge method error, device: ${device}, method: ${method}`);
    this.name = this.constructor.name;
    window?.newrelic.noticeError(this, {
      device,
      method,
    });
  }
}

export class PageNotFoundError extends Error {
  constructor(path: any) {
    super(`Page not found at: ${path}`);
    this.name = this.constructor.name;
    window?.newrelic.noticeError(this, {
      path,
    });
  }
}
